import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    OTHER_EQUIPMENT_HOSPITAL_LIST,
    OTHER_EQUIPMENT_LIST,
    OTHER_EQUIPMENT_EDIT,
    OTHER_EQUIPMENT_EQP,
} from "../../actions";

import {
    OtherEquipmentHospitalListSuccess,
    OtherEquipmentHospitalListError,
    OtherEquipmentListSuccess,
    OtherEquipmentListError,
    OtherEquipmentEditSuccess,
    OtherEquipmentEditError,
    OtherEquipmentEqpSuccess,
    OtherEquipmentEqpError,
} from '../../actions';

export function* watchOtherEquipmentHospitalList() {
    yield takeEvery(OTHER_EQUIPMENT_HOSPITAL_LIST, onOtherEquipmentHospitalList);
}

export function* watchOtherEquipmentList() {
    yield takeEvery(OTHER_EQUIPMENT_LIST, onOtherEquipmentList);
}

export function* watchOtherEquipmentEdit() {
    yield takeEvery(OTHER_EQUIPMENT_EDIT, onOtherEquipmentEdit);
}

export function* watchOtherEquipmentEqp() {
    yield takeEvery(OTHER_EQUIPMENT_EQP, onOtherEquipmentEqp);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onOtherEquipmentHospitalListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'otherreassignation/hospital', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onOtherEquipmentListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'otherreassignation/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onOtherEquipmentEditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'otherreassignation/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onOtherEquipmentEqpAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'otherreassignation/equipment', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onOtherEquipmentHospitalList(data) {
    try {
        const response = yield call(onOtherEquipmentHospitalListAsync, data.payload);
        yield put(OtherEquipmentHospitalListSuccess(response.data));
    } catch (error) {
        yield put(OtherEquipmentHospitalListError(error));
    }
}

function* onOtherEquipmentList(data) {
    try {
        const response = yield call(onOtherEquipmentListAsync, data.payload);
        yield put(OtherEquipmentListSuccess(response.data));
    } catch (error) {
        yield put(OtherEquipmentListError(error));
    }
}

function* onOtherEquipmentEdit(data) {
    try {
        const response = yield call(onOtherEquipmentEditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(OtherEquipmentEditSuccess(response.data));
    } catch (error) {
        yield put(OtherEquipmentEditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onOtherEquipmentEqp(data) {
    try {
        const response = yield call(onOtherEquipmentEqpAsync, data.payload);
        yield put(OtherEquipmentEqpSuccess(response.data));
    } catch (error) {
        yield put(OtherEquipmentEqpError(error));
    }
}



export default function* rootSaga() {
    yield all([
        fork(watchOtherEquipmentHospitalList),
        fork(watchOtherEquipmentList),
        fork(watchOtherEquipmentEdit),
        fork(watchOtherEquipmentEqp),
    ]);
}
